import React from "react";
import "./Checkbox.css";
interface checkboxProps {
  disabled: boolean;
  inputType: string;
  name?: string;
  errorMessage?: string | undefined | string[];
  iserror?: boolean;
  value?: string | number | boolean;
  label?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
}
export const Checkbox = ({
  disabled,
  inputType,
  name,
  errorMessage,
  iserror,
  value,
  label,
  onChange,
  onBlur,
}: checkboxProps) => {
  return (
    <>
      <div
        className="checkbox-group"
        style={disabled ? { pointerEvents: "none", opacity: 0.4 } : {}}>
        <div className="checkbox-wrapper-label">
          <label className="checkbox-label">
            <p>{label}</p>
          </label>
        </div>
        <div className="checkbox-wrapper-checkbox">
          <input
            name={name}
            // value={value}
            type="checkbox"
            className="checkbox-checkbox"></input>
          {/* {true && <div className="input-error">{"errorMessage"}</div>} */}
        </div>
      </div>
      {/* <div
        className="input-group"
        style={disabled ? { pointerEvents: "none", opacity: 0.4 } : {}}>
        <div className="input-wrapper-label">
          <label className="input-label">
            <p>{label}</p>
          </label>
        </div>
 
        <div className="input-wrapper-textbox">
          <input
            style={{
              border: iserror ? "1.5px solid red" : undefined,
            }}
            type={inputType}
            name={name}
            value={value}
            className="input-textbox"
            onChange={disabled ? undefined : onChange}
            onBlur={onBlur}></input>
          {iserror && <div className="input-error">{errorMessage}</div>}
        </div>
      </div> */}
    </>
  );
};
